<template>
    <v-flex
        align="center"
        class="vh-100 bg-white text-dark"
        direction="column"
        v-if="shared.initialized"
    >
        <div class="header p-4 bg-dark mb-4 w-100 text-white">
            <Wordmark class="logo" />
        </div>
        <router-view class="content flex-grow-1" />
        <ladder-footer class="border-top w-100"></ladder-footer>
    </v-flex>
</template>

<script>
import LadderFooter from "@/components/LadderFooter";
import Wordmark from "@/components/Wordmark";
import store from "@/store";

export default {
    name: "CheckoutLayout",
    components: {
        LadderFooter,
        Wordmark
    },
    data() {
        return {
            shared: store.state
        };
    },
    computed: {
        backText() {
            // Give the users an option to return to the page they came from (with context)
            if (!this.lastRoute || !this.lastRoute.name) {
                return null;
            }
            if (this.lastRoute.name == "CoachPage") {
                return "Go back to coach page";
            }
            if (this.lastRoute.name == "InviteLanding") {
                return "Go back to invitation";
            }
            return null;
        }
    },
    mounted() {
        document.body.classList.add("light");
    },
    updated() {
        document.body.classList.add("light");
    },
    beforeDestroy() {
        document.body.classList.remove("light");
    }
};
</script>

<style scoped lang="scss">
.content {
    width: 60%;
}
@media (max-width: #{map-get($grid-breakpoints, "md")}) {
    .content {
        width: 100%;
    }
}
</style>
